import { render, staticRenderFns } from "./autotemplate.vue?vue&type=template&id=22652d54&scoped=true&"
import script from "./autotemplate.vue?vue&type=script&lang=js&"
export * from "./autotemplate.vue?vue&type=script&lang=js&"
import style0 from "./autotemplate.vue?vue&type=style&index=0&id=22652d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22652d54",
  null
  
)

export default component.exports